import { useState } from 'react';
import styles from '../../styles/profileCard.module.scss';
import { useAuth } from '../../context/useAuth';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ProfileCard = ({ onOpenModal }) => {
  const { user, logout } = useAuth();
  const [isUserDetailsModalOpen, setIsUserDetailsModalOpen] = useState(false);

  const handleOpenUserDetails = () => {
    if (onOpenModal) onOpenModal();
    setTimeout(() => setIsUserDetailsModalOpen(true), 100);
  };

  const handleCloseUserDetails = () => {
    setIsUserDetailsModalOpen(false);
  };

  return (
    <div className={styles.profileCardContainer}>
      <div className={styles.profileCard}>
        <div className={styles.profileCard__header}>Opcije</div>
        <Link to="/profile" style={{ textDecoration: 'none' }}>
          <div className={styles.profileCard__item}>
            <img src="/assets/icons/edit-icon.svg" alt="edit icon" />
            <span>Uredi profil</span>
          </div>
        </Link>
        <div className={styles.profileCard__item} onClick={() => logout()}>
          <img src="/assets/icons/logout-icon.svg" alt="edit icon" />
          <span>Odjavi se</span>
        </div>
        {/* <div className={styles.profileCard__profileDetails}>
          <div
            style={{
              padding: user?.profileImage ? '0' : '8px',
            }}
            className={styles.profileCard__profileDetails__imageContainer}
          >
            <img
              src={user?.profileImage || '/assets/icons/user.svg'}
              alt="user_icon"
            />
          </div>
          <div>
            <span className={styles.profileCard__profileDetails__name}>
              {user?.type === 'individual' ? (
                <>
                  {user.firstName} {user.lastName}
                </>
              ) : (
                <>{user.responsibleName}</>
              )}
            </span>
            <br />
            <span className={styles.profileCard__profileDetails__email}>
              {user.email}
            </span>
          </div>
        </div> */}

        {/* <div className={styles.profileCard__optionsContainer}>
          <span className={styles.profileCard__profileDetails__email}>
            Opcije
          </span>
          <div
            className={styles.profileCard__optionsContainer__buttonContainer}
          >
            <Button
              type="default"
              className="btn-tertiary"
              onClick={handleOpenUserDetails}
            >
              Pogledaj nalog
            </Button>
            <Button
              className={`btn-tertiary ${styles.profileCard__optionsContainer__logoutButton}`}
              onClick={() => logout()}
            >
              Odjavi se
            </Button>
          </div>
        </div> */}
      </div>

      {/* <UserDetailsModal
        isOpen={isUserDetailsModalOpen}
        onClose={handleCloseUserDetails}
      /> */}
    </div>
  );
};

ProfileCard.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
};

export default ProfileCard;
